import { useEffect, useState } from "react";
import PageContainer from "../../Component/Common/Page";
import PageHeader from "../../Component/Common/PageHeader";
import ReactApexChart from "react-apexcharts";
import { ReactComponent as VideoIcon } from "../../assets/icons/VideoIcon.svg";
import { ReactComponent as UserTotalIcon } from "../../assets/icons/UserSideBarIcon.svg";
import { ReactComponent as TotalChannelIcon } from "../../assets/icons/ChannelIcon.svg";
import { ReactComponent as TotalShortsIcon } from "../../assets/icons/ShortIcon.svg";
import { ReactComponent as EyeIcon } from "../../assets/icons/EyesIcon.svg";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  getDashboardCount,
  getDashboardUserChart,
  getChartAnalyticOfActiveUser,
} from "../../store/dashboard/dashboard.action";

const Dashboard = (props) => {
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("All");
  const [endDate, setEndDate] = useState("All");
  const {
    dashboardCount,
    chartAnalyticOfVideos,
    chartAnalyticOfShorts,
    chartAnalyticOfUsers,
    chartAnalyticOfActiveUser,
  } = useSelector((state) => state.dashboard);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  let label = [];

  let usersMap = new Map();
  let videoMap = new Map();
  let shortMap = new Map();

  const startDateFormat = (startDate) => {
    return startDate && dayjs(startDate).isValid()
      ? dayjs(startDate).format("YYYY-MM-DD")
      : dayjs().subtract(7, "day").format("YYYY-MM-DD");
  };
  const endDateFormat = (endDate) => {
    return endDate && dayjs(endDate).isValid()
      ? dayjs(endDate).format("YYYY-MM-DD")
      : dayjs().format("YYYY-MM-DD");
  };

  const startDateData = startDateFormat(startDate);
  const endDateData = endDateFormat(endDate);

  useEffect(() => {
    dispatch(getDashboardCount(startDate, endDate));
  }, [dispatch, startDate, endDate]);

  useEffect(() => {
    dispatch(getDashboardUserChart(startDate, endDate, "Short"));
  }, [dispatch, startDate, endDate]);
  useEffect(() => {
    dispatch(getDashboardUserChart(startDate, endDate, "Video"));
  }, [dispatch, startDate, endDate]);
  useEffect(() => {
    dispatch(getDashboardUserChart(startDate, endDate, "User"));
  }, [dispatch, startDate, endDate]);

  useEffect(() => {
    dispatch(getChartAnalyticOfActiveUser(startDate, endDate));
  }, [dispatch, startDate, endDate]);

  // Process users' data
  chartAnalyticOfUsers?.forEach((data_) => {
    const newDate = data_?._id;
    const date = newDate;
    label.push(date);
    usersMap.has(date)
      ? usersMap.set(date, usersMap.get(date) + data_.count)
      : usersMap.set(date, data_?.count || 0);
  });

  chartAnalyticOfVideos?.forEach((data_) => {
    const newDate = data_?._id;
    const date = newDate;
    label.push(date);
    videoMap.has(date)
      ? videoMap.set(date, videoMap.get(date) + data_.count)
      : videoMap.set(date, data_?.count || 0);
  });

  // Process shorts' data
  chartAnalyticOfShorts?.forEach((data_) => {
    const newDate = data_?._id;
    const date = newDate;
    label.push(date);
    shortMap.has(date)
      ? shortMap.set(date, shortMap.get(date) + data_.count)
      : shortMap.set(date, data_?.count || 0);
  });

  let labelSet = new Set(label);
  // Convert labelSet back to array and sort
  label = [...labelSet].sort((a, b) => new Date(a) - new Date(b));

  // Ensure all arrays have the same length and are aligned properly with labels
  const maxLength = label?.length;

  for (let i = 0; i < maxLength; i++) {
    if (!usersMap.has(label[i])) {
      usersMap.set(label[i], 0);
    }
    if (!videoMap.has(label[i])) {
      videoMap.set(label[i], 0);
    }
    if (!shortMap.has(label[i])) {
      shortMap.set(label[i], 0);
    }
  }
  var webSize = $(window).width();
  const resHeight =
    webSize >= 992 ? 500 : webSize < 992 && webSize > 576 ? 400 : 300;

  const totalSeries = {
    labels: label,
    dataSet: [
      {
        name: "Total User",
        data: Array.from(usersMap).sort((a, b) => new Date(a[0]) - new Date(b[0])).map((entry) => entry[1]),
      },
      {
        name: "Total Video",
        data: Array.from(videoMap).sort((a, b) => new Date(a[0]) - new Date(b[0])).map((entry) => entry[1]),
      },
      {
        name: "Total Short",
        data: Array.from(shortMap).sort((a, b) => new Date(a[0]) - new Date(b[0])).map((entry) => entry[1]),
      },
    ],
  };

  const optionsTotal = {
    chart: {
      type: "area",
      stacked: false,
      height: "200px",
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    markers: {
      size: 0,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.45,
        opacityTo: 0.05,
        stops: [20, 100, 100, 100],
      },
    },
    yaxis: {
      show: false,
    },
    xaxis: {
      categories: label,
      rotate: 0,
      rotateAlways: true,
      minHeight: 50,
      maxHeight: 100,
      labels: {
        offsetX: -4, // Adjust the offset vertically
        fontSize: 10,
      },
    },

    tooltip: {
      shared: true,
    },
    legend: {
      position: "top",
      horizontalAlign: "right",
      offsetX: -10,
    },
    colors: ["#FD4D66", "#786D81", "#e91e63"],
  };

  const activeUserData = chartAnalyticOfActiveUser?.reduce(function (acc, obj) {
    return acc + obj?.count;
  }, 0);
  const userData = chartAnalyticOfUsers?.reduce(function (acc, obj) {
    return acc + obj?.count;
  }, 0);
  const percentage = (activeUserData / userData) * 100;
  const seriesGradient = [percentage ? percentage?.toFixed(0) : "0"];

  const optionsGradient = {
    chart: {
      height: 350,
      width: 200,
      type: "radialBar",
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      radialBar: {
        startAngle: 0,
        endAngle: 365,
        hollow: {
          margin: 0,
          size: "55%",
          background: "#fff",
          image: undefined,
          imageOffsetX: 0,
          imageOffsetY: 0,
          position: "front",
          dropShadow: {
            enabled: false,
            top: 3,
            left: 0,
            blur: 4,
            opacity: 0.24,
          },
        },
        track: {
          background: "#EDEDED", // Change the background color here
          strokeWidth: "90%",
          margin: 0, // margin is in pixels
          dropShadow: {
            enabled: false,
            top: -3,
            left: 0,
            blur: 4,
            opacity: 0.35,
          },
        },
        dataLabels: {
          show: true,
          name: {
            offsetY: 25,
            show: true,
            color: "#404040",
            fontSize: "17px",
            text: "Active User", // Set the label text
          },
          value: {
            offsetY: -25,
            formatter: function (val) {
              return parseInt(val) + "%";
            },
            color: "#F14F66",
            fontWeight: 600,
            fontSize: "30px",
            show: true,
          },
        },
      },
    },
    fill: {
      type: "solid",
      colors: ["#F14F66"],
    },
    labels: ["Block User"],
    stroke: {
      lineCap: "round",
    },
  };

  return (
    <PageContainer className="dashboard ">
      <PageHeader
        heading={"Welcome Admin"}
        subHeading={"Dashboard"}
        showDateRange={true}
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />

      <div className="dashBoardMain pt-2">
        <div className="row dashboard-count-box">
          <div
            className="  adminProfileBox px-2   col-lg-3 col-md-6 col-sm-12 cursor"
            onClick={() => navigate("/admin/userTable")}
          >
            <div className="dashBoxData bg-white">
              <div className="icon icon-sm icon-shape-small  text-center border-radius-xl my-auto icon-data1">
                <UserTotalIcon />
              </div>
              <div className="dashBox-text">
                <h5 className="text-center">Total User</h5>
                <h6 className="text-center pt-3  fw-bold">
                  {dashboardCount?.totalUsers
                    ? dashboardCount?.totalUsers
                    : "0"}
                </h6>
              </div>
            </div>
          </div>
          <div
            className="  adminProfileBox px-2   col-lg-3 col-md-6 col-sm-12 cursor"
            onClick={() => navigate("/admin/channel")}
          >
            <div className="dashBoxData bg-white">
              <div className="icon icon-sm icon-shape-small  text-center border-radius-xl my-auto icon-data1">
                <TotalChannelIcon />
              </div>
              <div className="dashBox-text">
                <h5 className="text-center">Total Channel</h5>
                <h6 className="text-center pt-3  fw-bold">
                  {dashboardCount?.totalChannels
                    ? dashboardCount?.totalChannels
                    : "0"}
                </h6>
              </div>
            </div>
          </div>
          <div
            className="  adminProfileBox px-2  col-lg-3 col-md-6 col-sm-12  cursor"
            onClick={() => navigate("/admin/videos")}
          >
            <div className="dashBoxData bg-white">
              <div className="icon icon-sm icon-shape-small  text-center border-radius-xl my-auto icon-data1">
                <VideoIcon />
              </div>
              <div className="dashBox-text">
                <h5 className="text-center">Total Video</h5>
                <h6 className="text-center pt-3  fw-bold">
                  {dashboardCount?.totalVideos
                    ? dashboardCount?.totalVideos
                    : "0"}
                </h6>
              </div>
            </div>
          </div>

          <div
            className="  adminProfileBox px-2  col-lg-3 col-md-6 col-sm-12 cursor"
            onClick={() => navigate("/admin/shorts")}
          >
            <div className="dashBoxData bg-white">
              <div className="icon icon-sm icon-shape-small  text-center border-radius-xl my-auto icon-data1">
                <TotalShortsIcon />
              </div>
              <div className="dashBox-text">
                <h5 className="text-center">Total Shorts</h5>
                <h6 className="text-center pt-3  fw-bold">
                  {dashboardCount?.totalShorts
                    ? dashboardCount?.totalShorts
                    : "0"}
                </h6>
              </div>
            </div>
          </div>

          <div className="adminProfileBox px-2 col-lg-3 col-md-6 col-sm-12">
            <div className="dashBoxData bg-white">
              <div className="icon icon-sm icon-shape-small text-center border-radius-xl my-auto icon-data1">
                <VideoIcon />
              </div>
              <div className="dashBox-text">
                <h5 className="text-center">Total Video by Organizations</h5>
                <h6 className="text-center pt-3  fw-bold">
                  {dashboardCount?.totalVideoByOrg
                    ? dashboardCount?.totalVideoByOrg
                    : "0"}
                </h6>
              </div>
            </div>
          </div>

          <div className="adminProfileBox px-2 col-lg-3 col-md-6 col-sm-12">
            <div className="dashBoxData bg-white">
              <div className="icon icon-sm icon-shape-small text-center border-radius-xl my-auto icon-data1">
                <VideoIcon />
              </div>
              <div className="dashBox-text">
                <h5 className="text-center">Total Video by Users</h5>
                <h6 className="text-center pt-3  fw-bold">
                  {dashboardCount?.totalVideoByUser
                    ? dashboardCount?.totalVideoByUser
                    : "0"}
                </h6>
              </div>
            </div>
          </div>

          <div className="adminProfileBox px-2 col-lg-3 col-md-6 col-sm-12">
            <div className="dashBoxData bg-white">
              <div className="icon icon-sm icon-shape-small text-center border-radius-xl my-auto icon-data1">
                <EyeIcon />
              </div>
              <div className="dashBox-text">
                <h5 className="text-center">Total Views</h5>
                <h6 className="text-center pt-3  fw-bold">
                  {dashboardCount?.totalWatchHistories
                    ? dashboardCount?.totalWatchHistories
                    : "0"}
                </h6>
              </div>
            </div>
          </div>
          <div className="adminProfileBox px-2 col-lg-3 col-md-6 col-sm-12">
            <div className="dashBoxData bg-white">
              <div className="icon icon-sm icon-shape-small text-center border-radius-xl my-auto icon-data1">
                <EyeIcon />
              </div>
              <div className="dashBox-text">
                <h5 className="text-center">Total Minutes Views</h5>
                <h6 className="text-center pt-3  fw-bold">
                  {dashboardCount?.totalMinutesViewed
                    ? dashboardCount?.totalMinutesViewed
                    : "0"}
                </h6>
              </div>
            </div>
          </div>
        </div>
        <div className="dashboard-analytics">
          <h6 className="heading-dashboard">Data Analytics</h6>
          <div className="row dashboard-chart justify-content-between">
            <div
              className="col-lg-9 col-md-12 col-sm-12 mt-lg-0 mt-4 dashboard-chart-box"
              style={{ position: "relative" }}
            >
              <div
                id="chart"
                className="dashboard-user-count"
                style={{ height: "100%" }}
              >
                <div className="">
                  <ReactApexChart
                    options={optionsTotal}
                    series={
                      totalSeries.dataSet.length >= 1 ? totalSeries.dataSet : ""
                    }
                    type="area"
                    height={"380px"}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-12  col-sm-12 mt-3 mt-lg-0 dashboard-total-user">
              <div className="user-activity">
                <h6
                  style={{
                    color: "#000000",
                    fontWeight: "600",
                    fontSize: "22px",
                  }}
                >
                  Total User Activity
                </h6>
                <div
                  id="chart"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <ReactApexChart
                    options={optionsGradient}
                    series={seriesGradient}
                    type="radialBar"
                    width={380}
                    height={"300px"}
                  />
                </div>
                <div className="total-user-chart">
                  <span></span>
                  <h5>Total User</h5>
                </div>
                <div className="total-active-chart">
                  <span></span>
                  <h5>Total Block User</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default connect(null, {
  getDashboardCount,
  getDashboardUserChart,
  getChartAnalyticOfActiveUser,
})(Dashboard);
